function pageNavigation() {
    const pageNavigation = document.querySelector('.page_navigation');
    const header = document.querySelector('header-component');


    function calculateSpaceHeight() {
        if(pageNavigation === null || header === null) return;
        const pageNavigationHeight = parseFloat(pageNavigation.offsetHeight);
        const headerHeight = parseFloat(header.offsetHeight);
        const spaceHeight = pageNavigationHeight + headerHeight;

        document.querySelectorAll('.page_category__scroll_spacer').forEach(function(element) {
            element.style.marginTop = -Math.abs(parseFloat(spaceHeight)) + 'px';
        });

        return parseFloat(spaceHeight);        
    }

    const spaceHeight = calculateSpaceHeight();

    function pageNavigationLinkInit(linkElement){
        if(linkElement === undefined || linkElement === null) return;
        const linkElementHref = linkElement.getAttribute('href');

        if(linkElementHref === undefined || linkElementHref === null || linkElementHref === '') return;
        const matchedElLength = document.querySelectorAll(`body ${linkElementHref}`).length;

        if(matchedElLength === 1) return;
        if(matchedElLength === 0) {
            linkElement.remove();
            return;
        }
        // Make check to make sure, there are not two (or more) elements with same ID
        document.querySelectorAll(`body ${linkElementHref}`).forEach((matchedEl, index) => {
            if(index !== 0) matchedEl.removeAttribute('id');
        })
    }


    document.querySelectorAll('.page_navigation a').forEach(function(element) {
        pageNavigationLinkInit(element);
    
        element.addEventListener('click', function(event) {
            event.preventDefault(); 

            const parent = this.parentNode;
            const siblings = parent.querySelectorAll('a');
            siblings.forEach(function(sibling) {
                sibling.classList.remove('active');
            });
            this.classList.add('active');
    
            const targetId = this.getAttribute('href').substring(1);
            const targetElement = document.getElementById(targetId);
    
            smoothScrollTo(targetElement, 500); 
    
        
        });
    });
    
    function smoothScrollTo(target, duration) {
        const start = window.pageYOffset;
        const targetPosition = target.getBoundingClientRect().top;
        const startTime = performance.now();
    
        function animation(currentTime) {
            const elapsedTime = currentTime - startTime;
            const ease = easeInOutQuad(elapsedTime, start, targetPosition, duration);
    
            window.scrollTo(0, ease);
    
            if (elapsedTime < duration) {
                requestAnimationFrame(animation);
            } else {
                window.scrollTo(0, start + targetPosition);
            }
        }
    
        requestAnimationFrame(animation);
    }
    
    function easeInOutQuad(time, start, change, duration) {
        time /= duration / 2;
        if (time < 1) return change / 2 * time * time + start;
        time--;
        return -change / 2 * (time * (time - 2) - 1) + start;
    }
    
    
    
    window.addEventListener('scroll', function() {
        document.querySelectorAll('.page_category__scroll_spacer').forEach(function(element) {
            const id = element.getAttribute('id');
            if( id === undefined || id === null || id === '') return;
            const parentElement = element.parentElement;
            const parentElementOffsetTop = parseFloat(parentElement.offsetTop);
            const parentElementOffsetBottom = parseFloat(parentElementOffsetTop) + parseFloat(parentElement.offsetHeight);

            if (window.scrollY >= (parentElementOffsetTop - spaceHeight) && window.scrollY <= parentElementOffsetBottom - spaceHeight) {

                document.querySelectorAll('.page_navigation a').forEach(function(navLink) {
                    if (navLink !== undefined || navLink !== null) navLink?.classList.remove('active');
                    
                });
                const pageNavigationLink = document.querySelector('.page_navigation a[href="#' + id + '"]');
                if (pageNavigationLink !== undefined || pageNavigationLink !== null) pageNavigationLink?.classList.add('active');
                
            }
        });
    });
}

if(document.querySelector(".page_navigation")) pageNavigation();
